module.exports = __webpack_public_path__ + "img/logistics-1.349d501b.png";